import { useState } from "react";
import empty from "../../../../assets/images/empty_state.png";
import { Card } from "../../../../components/ui/card";
import { Categories } from "../../../../constants";
import VulnerabilityDetails from "../../Report/modals/VulnerabilityDetails";
// import { cn } from "../../../../lib/utils";

const VulnerabilityTable = ({ topVulnerability }) => {
  const data = topVulnerability;
  // const [showExtra, setShowExtra] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [details, setDetails] = useState(null);

  return (
    <div className="flex flex-col">
      <h2 className="font-semibold mb-2">Top Vulnerabilities</h2>
      <p className="text-sm text-neutral600 mb-4">
        See top 5 vulnerabilities ranked by severity and potential impact.
      </p>
      {data?.length > 0 ? (
        <div className="overflow-x-auto">
          <div className="w-full border min-w-[800px] border-neutral300 rounded-lg text-sm">
            <div className="flex justify-between gap-4 text-left px-3 xl:px-6 py-2 bg-neutral3 rounded-t-lg border-b text-neutral700 font-medium w-full">
              {/* <span className="flex-1">Target</span> */}
              <span className="w-[35%] text-left mr-2">Name</span>
              <span className="w-[20%] text-left">Risks</span>
              <span className="flex-1 text-center mr-2">Severity</span>
              <span className="w-[25%] text-left">Host</span>
            </div>
            <div className="rounded-b-lg">
              {data?.slice(0, 5)?.map((item, index) => {
                // const parts = item?.scan?.target?.target
                //   .split(",")
                //   .map((part) => part.trim());
                // console.log(parts)
                return (
                  <div
                    key={index}
                    className={`py-3 px-3 xl:px-6 flex gap-4 text-dark items-center text-sm ${
                      index === 0 ? "border-t-0" : "border-t border-t-[#EAECF0]"
                    } hover:bg-[#F9FAFB]`}
                  >
                    <div className="w-[35%] text-left mr-2 ">
                      <p
                        className="text-neutral1000 underline underline-offset-4 neutral1000 w-fit font-medium cursor-pointer"
                        onClick={() => {
                          setDetails(item);
                          setIsOpen(true);
                        }}
                      >
                        {item.vulnerability_name}
                      </p>
                    </div>
                    <div className="w-[20%] flex gap-2 ">
                      {item?.category?.slice(0, 5)?.map((cate, index) => {
                        const match = Categories.find(
                          (cat) =>
                            cat.title.toLowerCase() === cate.toLowerCase()
                        );

                        if (!match) return null;

                        const Icon = match.icon;

                        return (
                          <div
                            key={index}
                            className="relative group flex items-center justify-center w-7 h-7 rounded"
                            style={{ backgroundColor: match.background }}
                          >
                            <Icon
                              className="w-5 h-5"
                              style={{ color: match.color }}
                            />
                            <div className="absolute top-full mt-2 hidden w-max max-w-xs text-xs text-black bg-white border px-2 py-1 rounded group-hover:block whitespace-nowrap z-10">
                              {match.title}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="flex-1 text-center mr-2 text-xs">
                      {item.threat_level === "Low" ? (
                        <p className="bg-success10 text-success100 border-[1.5px] rounded-full border-[#00C8511A] w-fit px-2 py-1 mx-auto">
                          {item.threat_level}
                        </p>
                      ) : item.threat_level === "Log" ? (
                        <p className="border-[#d3e8f1] text-[#0BA5EC] bg-[#F1F8FF]  border-[1.5px] rounded-full w-fit px-2 py-1 mx-auto">
                          Info
                        </p>
                      ) : item.threat_level === "Medium" ? (
                        <p className="border-cream100 text-brown100 border-[1.5px] rounded-full bg-[#FFBB331A] w-fit px-2 py-1 mx-auto">
                          Medium
                        </p>
                      ) : item.threat_level === "High" ? (
                        <p className="border-[#F973161A] text-[#E3650F] border-[1.5px] rounded-full bg-[#F973161A] w-fit px-2 py-1 mx-auto">
                          High
                        </p>
                      ) : (
                        <p className="bg-[#FF44441A] text-[#E12A5B] border-[1.5px] rounded-full border-[#FFC1C1] w-fit px-2 py-1 mx-auto">
                          Critical
                        </p>
                      )}
                    </div>
                    <div className="w-[25%] relative flex-row flex gap-2 text-left break-all">
                      {/* {parts && parts.length > 0 && (
                        <div
                          key={index}
                          className={cn(
                            parts.length > 1 && "max-w-[150px]",
                            "w-fit px-2 py-1 rounded-full bg-neutral200"
                          )}
                        >
                          <p className="truncate">{parts[0]}</p>
                        </div>
                      )}
                      {parts && parts.length > 1 && (
                        <div
                          className="w-fit px-[10px] py-1 rounded-full bg-neutral200 cursor-pointer"
                          onMouseEnter={() => setShowExtra(index)}
                          onMouseLeave={() => setShowExtra(null)}
                        >
                          +{parts.length - 1}
                          {showExtra === index && (
                            <div className="absolute left-0 ml-0 bg-white border rounded shadow px-2 py-1 z-10">
                              {parts.slice(1, 4).join(", ")}
                              {parts.length > 4 && " ..."}
                            </div>
                          )}
                        </div>
                      )} */}
                      <p>
                        {item?.processed_host || "--"}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <Card className="h-[45vh] w-full flex justify-center flex-col items-center text-center p-4">
          <img src={empty} alt="empty" />
          <p className=" font-semibold my-2 text-darkGrey">
            No Vulnerabilities Found
          </p>
          <p className="text-neutral600 text-sm">
            Your assets are currently free of top vulnerabilities.
          </p>
          <p className="text-neutral600 text-sm">Great job staying secure!</p>
        </Card>
      )}

      <VulnerabilityDetails
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        details={details}
      />
    </div>
  );
};

export default VulnerabilityTable;
